module.exports = __webpack_public_path__ + "img/logo.e5af5681.png";